module.exports = __webpack_public_path__ + "img/ione11.9ab86440.png";